import useService from '../../../../../../services/hooks/useService'
import AuthenticationService from '../../../../../../services/AuthenticationService'
import useRequest from '../../../../../../services/hooks/useRequest'
import useError from '../../../../../../services/hooks/useError'

export default function useSubmit({ email, onSuccess }) {
  const authenticationService = useService(AuthenticationService)
  const { exec, loading, error } = useRequest(authenticationService.signInWithEmailAndPassword)
  useError(error, 'sign-in')

  const handleSubmit = async (values) => {
    const result = await exec(email, values.Password)
    if (result?.Token) {
      onSuccess && onSuccess(result.Token)
    }
  }

  return { handleSubmit, loading }
}
